import { type SortingField } from ".";

export const BOOKINGS_SORT_FIELDS = [
  "ID",
  "NAME",
  "CREATED_AT",
  "UPDATED_AT",
  "PLANNED_SHIPPING_DATE",
  "STATUS",
  "ACCOUNT_MANAGER_LAST_NAME",
  "NUMBER_OF_HEAD",
  "SOURCE_PARTNER_BUSINESS_NAME",
  "DESTINATION_PARTNER_BUSINESS_NAME",
  "LOT_NUMBER",
  "PEN_NUMBER",
  "ACCOUNT_NUMBER",
  "SEX_CLASS",
  "BREED_NOTE",
  "CONFIRMED",
  "CONDITION",
  "OWNERSHIP_TYPE",
  "DATE_OF_SALE",
  "DATE_OF_VISIT",
  "PROJECTED_OUT_DATE",
  "DATE_DELIVERED",
  "PRICE",
  "FREIGHT_COST",
  "SLIDE",
  "PURCHASE_PRICE_PER_CWT",
  "RISK_MANAGEMENT",
  "SHIPPED_WEIGHT",
  "BASE_WEIGHT",
  "ESTIMATED_CHOICE_PERCENT",
  "SHRINK_PERCENT",
  "ESTIMATED_WEIGHT_NOTE",
  "SOURCE_NOTE",
  "BRAND_NOTE",
  "CERTIFICATE_NUMBER",
  "PROGRAM_LABEL",
  "GRID_LABEL",
  "TRUCKING_COMPANY",
  "BROKER_BUSINESS_NAME",
  "VETERINARIAN_LAST_NAME",
  "SERVICE_PROVIDED",
] as const satisfies readonly SortingField[];

export type BookingsSortField = (typeof BOOKINGS_SORT_FIELDS)[number];
